import { Formik } from 'formik';
import { FC } from 'react';
import * as yup from 'yup';
import { useFormContext } from '../../../../../contexts/FormContext';
import { MarketingIdeasInput, FormType } from '../../../../../types/FormTypes';
import { ListenToFormikValues } from '../../../../shared/formik/ListenToFormikValues';
import { GenerateResponseButtons } from '../GenerateResponseButtons';
import styles from './MarketingIdeas.module.css';
import formStyles from '../formStyles.module.css';
import { IntentSelectionInput } from '../formInputs/IntentInput';
import { CompanyNameWebsiteInputs } from '../formInputs/CompanyNameWebsiteInputs';
import { MarketingIdeasIntents } from '../../../../../types/FormOptions.type';
import {useRouter} from 'next/router';
import { ToggleInput } from '../../../../shared/inputs/ToggleInput';
import { SmallerSimpleBadge } from '../../../../shared/badge/SmallerSimpleBadge';

const MarketingIdeasInputsSchema = yup.object<
  Record<keyof MarketingIdeasInput, yup.AnySchema>
>({
  companyName: yup.string().required("Please add your company's name"),
  companyWebsite: yup.string().notRequired(),
  intent: yup.string().required('Please select the goal of your '),
  prevResponse: yup.string().notRequired(),
  advancedInputs: yup.boolean().notRequired(),
});

export const MarketingIdeasForm: FC = () => {
  const {
    marketingIdeasInput,
    setMarketingIdeasInput,
    setCanKeepGoing,
    loading,
    submitBrainstormForm,
  } = useFormContext();
  const router = useRouter();

  return (
    <Formik
      initialValues={marketingIdeasInput}
      onSubmit={async (values, actions) => {
        await submitBrainstormForm({
          values,
          actions,
          formType: FormType.MARKETINGIDEAS,
        });
      }}
      validationSchema={MarketingIdeasInputsSchema}
    >
      {(props) => (
        <>
          <div className={formStyles['form-container']}>
            <ListenToFormikValues
              callBackFunc={(values) => {
                setMarketingIdeasInput(values as MarketingIdeasInput);
                setCanKeepGoing(false);
              }}
            />
            
            <div className={styles['toggle']}>
                   <div>
                 <ToggleInput
                 id='manualToggle'
                 disabled={false}
                 isChecked={false}
                 onClick={() => {
                  router.push('/editor/brainstorm?formType=persona%20marketing%20ideas')
                 }} 
                 />
                 </div>
              <div className={styles['toggle-name']}>
                <b>Persona Mode</b>
                </div>
                
                </div>
                <div className={styles['create-button2']}>
              <IntentSelectionInput
                formikProps={props}
                disabled={loading}
                title="What is the main goal of the campaign?"
                subtitle="Please select the desired outcome of the campaign"
                defaultOptions={Object.keys(MarketingIdeasIntents)}
                defaultOptionIcons={[
                  '/icons/GageBlack.svg',
                  '/icons/TargetArrowBlack.svg',
                  '/icons/DollarSignBlack.svg',
                ].map((src) => ({
                  src,
                  height: 16,
                  width: 16,
                }))}
              />
            </div>
            <div>
              <CompanyNameWebsiteInputs
                formikProps={props}
                disabled={loading}
                labelTitle="What are you marketing?"
              />
            </div>
          </div>
          <GenerateResponseButtons
            onSubmit={() => {
              props.handleSubmit();
            }}
          />
        </>
      )}
    </Formik>
  );
};
